"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CryptoInvoiceStatus = void 0;
var CryptoInvoiceStatus;
(function (CryptoInvoiceStatus) {
    CryptoInvoiceStatus["CREATED"] = "CREATED";
    CryptoInvoiceStatus["REGISTERED"] = "REGISTERED";
    CryptoInvoiceStatus["PENDING"] = "PENDING";
    CryptoInvoiceStatus["PAID"] = "PAID";
    CryptoInvoiceStatus["EXPIRED"] = "EXPIRED";
})(CryptoInvoiceStatus = exports.CryptoInvoiceStatus || (exports.CryptoInvoiceStatus = {}));
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiQ3J5cHRvSW52b2ljZVN0YXR1cy5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uL3NyYy9DcnlwdG9JbnZvaWNlU3RhdHVzLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUFBLElBQVksbUJBTVg7QUFORCxXQUFZLG1CQUFtQjtJQUM3QiwwQ0FBbUIsQ0FBQTtJQUNuQixnREFBeUIsQ0FBQTtJQUN6QiwwQ0FBbUIsQ0FBQTtJQUNuQixvQ0FBYSxDQUFBO0lBQ2IsMENBQW1CLENBQUE7QUFDckIsQ0FBQyxFQU5XLG1CQUFtQixHQUFuQiwyQkFBbUIsS0FBbkIsMkJBQW1CLFFBTTlCIn0=